module.exports = __webpack_public_path__ + "static/img/fdmPurpose3.07d1adf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fdmPurpose3.png
// module id = 0Bzw
// module chunks = 2